const trendGraphActions = {
  CLEAN_TREND_GRAPH_DATA: 'CLEAN_TREND_GRAPH_DATA',
  FETCH_TREND_GRAPH_DATA: 'FETCH_TREND_GRAPH_DATA',
  FETCH_TREND_GRAPH_DATA_SUCCESS: 'FETCH_TREND_GRAPH_DATA_SUCCESS',
  FETCH_TREND_GRAPH_DATA_ERROR: 'FETCH_TREND_GRAPH_DATA_ERROR',
  FETCH_TREND_GRAPH_DATA_CLEAN_STATE: 'FETCH_TREND_GRAPH_DATA_CLEAN_STATE',
};

const cleanGraphData = (data, callback = () => {}) => ({
  type: trendGraphActions.CLEAN_TREND_GRAPH_DATA,
  payload: data,
  callback,
});
const fetchGraphData = (data, callback = () => {}) => ({
  type: trendGraphActions.FETCH_TREND_GRAPH_DATA,
  payload: data,
  callback,
});
const fetchGraphDataSuccess = (data) => ({
  type: trendGraphActions.FETCH_TREND_GRAPH_DATA_SUCCESS,
  payload: data,
});
const fetchGraphDataError = ({ message }) => ({
  type: trendGraphActions.FETCH_TREND_GRAPH_DATA_ERROR,
  payload: message,
});
const fetchGraphDataCleanState = () => ({
  type: trendGraphActions.FETCH_TREND_GRAPH_DATA_CLEAN_STATE,
});

export {
  cleanGraphData,
  fetchGraphData,
  fetchGraphDataCleanState,
  fetchGraphDataError,
  fetchGraphDataSuccess,
  trendGraphActions
};

